webpackJsonp([159916935039157],{

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n\n  box-shadow: 0 0 10px #454545;\n"], ["\n  ", ";\n\n  box-shadow: 0 0 10px #454545;\n"]);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ShadowImage = _styledComponents2.default.img(_templateObject, function (_ref) {
	  var width = _ref.width;
	
	  if (width) {
	    return "width: " + width;
	  }
	});
	
	exports.default = ShadowImage;
	module.exports = exports["default"];

/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/adam.bf960d53.jpg";

/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/casey.51c0215e.jpg";

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n\n  flex: 1 0 40%;\n\n  margin: 0.5rem;\n"], ["\n  display: inline-block;\n\n  flex: 1 0 40%;\n\n  margin: 0.5rem;\n"]);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(12);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _FlexRow = __webpack_require__(63);
	
	var _FlexRow2 = _interopRequireDefault(_FlexRow);
	
	var _Card = __webpack_require__(62);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	var _ShadowImage = __webpack_require__(46);
	
	var _ShadowImage2 = _interopRequireDefault(_ShadowImage);
	
	var _adam = __webpack_require__(627);
	
	var _adam2 = _interopRequireDefault(_adam);
	
	var _casey = __webpack_require__(628);
	
	var _casey2 = _interopRequireDefault(_casey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var ImageContainer = _styledComponents2.default.div(_templateObject);
	
	var OurStoryPage = function OurStoryPage() {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _Card2.default,
	      { header: "Adam Fishman & Casey Lee" },
	      _react2.default.createElement(
	        _FlexRow2.default,
	        null,
	        _react2.default.createElement(
	          ImageContainer,
	          null,
	          _react2.default.createElement(_ShadowImage2.default, { src: _adam2.default })
	        ),
	        _react2.default.createElement(
	          ImageContainer,
	          null,
	          _react2.default.createElement(_ShadowImage2.default, { src: _casey2.default })
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "It was January 2017. Casey had just moved to Denver and was getting settled in at his new job and home. Adam was also getting settled into his new home after moving back to Denver from Colorado Springs. Casey had logged back into Plenty of Fish for the first time in quite a while just to see if he could meet some new people in the area since he didn't know anyone living in Denver at the time. Little did he know, he would soon meet Adam which would vault their life into something different and unexpected."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "During Casey's second week of employment in Denver, we started talking on Plenty of Fish and then we first met in person on the evening of February 4th after Casey had spent the day downtown at a Star Wars exhibit at the Denver Art Museum. We sat and talked over dinner for over four hours and then talked for a few more hours afterwards. After that night, we spent time together daily and it was all over from there."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We enjoyed a busy summer full of concerts, plays, and comedy shows allowing us to get to know each other more every day. By the time July rolled around, we decided that we wanted to live together. As a result, Casey moved into Adam's place along with him and his kitty Murphy."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "After a great holiday season together, it was New Year's Eve. We had a nice dinner that evening and afterwards, we went home to feed Murphy before heading downtown for fireworks. That was when Adam",
	        " ",
	        _react2.default.createElement(
	          "a",
	          { href: "http://wedding.adamsuniverse.com/proposal", target: "_blank" },
	          "proposed via a website"
	        ),
	        " ",
	        "that he had created based on our time together. Casey, of course, said YES!"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "A year to the day since first meeting, this website was released to our family and friends to announce the wedding of Adam and Casey on Saturday, August 18, 2018. We look forward to celebrating this special day with those closest to us."
	      )
	    )
	  );
	};
	
	exports.default = OurStoryPage;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-our-story-js-122ffefc256834870bad.js